import moment from "moment-timezone";

export const durationToString = (duration) => {
  let hours = duration.hours().toString().padStart(2, "0");
  let minutes = duration.minutes().toString().padStart(2, "0");
  let seconds = duration.seconds().toString().padStart(2, "0");

  return hours === "00" ? `${minutes}:${seconds}` : `${hours}:${minutes}:${seconds}`;
};

/**
 * Calculates Age given the Date of Birth
 * @param {string} dateOfBirth - Assumes MM/DD/YYYY format
 */
export const calculateAge = function (dateOfBirth) {
  if (!dateOfBirth) {
    return "";
  }
  const splitDate = dateOfBirth.split("/");
  const parsedDate = moment(`${splitDate[2]}-${splitDate[0]}-${splitDate[1]}`);
  const now = moment();

  return now.diff(parsedDate, "years");
};

export const convertToStandardTimeStampFormat = (momentInstance) => {
  return `${momentInstance.tz("UTC").format("YYYY-MM-DDTHH:mm:ss.SSSSSS")}Z`;
};

export const localTimestampFromStandardTimestamp = (standardTimestamp, outputFormat) => {
  const localCompletedTime = moment.utc(standardTimestamp, "YYYY-MM-DDTHH:mm:ss.SSSSSSZ").local();

  if (localCompletedTime.isValid()) {
    return localCompletedTime.format(outputFormat);
  }

  return "";
};
